import 'angular'
import 'angular-translate'
import './dashboard/index.js'
import './herramientas/index.js'



// WEBPACK FOOTER //
// ./src/index.js